import {combineReducers} from 'redux';
import dateRangeReducer from './dateRange/dateRangeReducer';
import PlanificationReducer from './planification/planificationReducer';
import hardwareReducer from './hardware/hardwareReducer'
const rootReducer = combineReducers({
    dateRange: dateRangeReducer,
    planification:PlanificationReducer,
    hardware: hardwareReducer
})
export default rootReducer;